import { HttpApiError } from "@effect/platform";
import { Schema } from "effect";
import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { ChannelThreadId, MessageId } from "../ids/definitions";
import { Message } from "../models/shopper-ai/conversation/message";
import { MetaCommentActionFailedError } from "../models/shopper-ai/conversation/message/meta-comment-action-error";
import { SupportTicketGroupBase } from "./support-ticket";

export const SupportTicketGroup = SupportTicketGroupBase.add(
  endpoint.merchant
    .post(
      "toggleCommentVisibility",
      "/support-tickets/comments/toggle-visibility",
    )
    .setPayload(
      Schema.Struct({
        threadId: ChannelThreadId,
        messageId: MessageId,
        commentId: Schema.String,
        platform: Schema.Literal("facebook", "instagram"),
        hide: Schema.Boolean,
      }),
    )
    .addSuccess(Schema.Struct({ message: Message }))
    .addError(HttpApiError.Forbidden)
    .addError(HttpApiError.BadRequest)
    .addError(HttpApiError.ServiceUnavailable)
    .addError(MetaCommentActionFailedError)
    .addError(DatabaseError)
    .addError(DataIntegrityError),
)
  .add(
    endpoint.merchant
      .post("deleteComment", "/support-tickets/comments/delete")
      .setPayload(
        Schema.Struct({
          threadId: ChannelThreadId,
          messageId: MessageId,
          commentId: Schema.String,
          platform: Schema.Literal("facebook", "instagram"),
        }),
      )
      .addSuccess(Schema.Struct({ message: Message }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(MetaCommentActionFailedError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("likeComment", "/support-tickets/comments/like")
      .setPayload(
        Schema.Struct({
          threadId: ChannelThreadId,
          messageId: MessageId,
          commentId: Schema.String,
        }),
      )
      .addSuccess(Schema.Struct({ message: Message }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(MetaCommentActionFailedError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("unlikeComment", "/support-tickets/comments/unlike")
      .setPayload(
        Schema.Struct({
          threadId: ChannelThreadId,
          messageId: MessageId,
          commentId: Schema.String,
        }),
      )
      .addSuccess(Schema.Struct({ message: Message }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(MetaCommentActionFailedError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post("updateComment", "/support-tickets/comments/update")
      .setPayload(
        Schema.Struct({
          threadId: ChannelThreadId,
          messageId: MessageId,
          commentId: Schema.String,
          newMessage: Schema.String,
        }),
      )
      .addSuccess(Schema.Struct({ message: Message }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(MetaCommentActionFailedError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    endpoint.merchant
      .post(
        "sendCommentPrivateReply",
        "/support-tickets/comments/private-reply",
      )
      .setPayload(
        Schema.Struct({
          threadId: ChannelThreadId,
          messageId: MessageId,
          commentId: Schema.String,
          platform: Schema.Literal("facebook", "instagram"),
          message: Schema.String,
        }),
      )
      .addSuccess(Schema.Struct({ message: Message }))
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.BadRequest)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(MetaCommentActionFailedError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
